import validate from "/codebuild/output/src2732330269/src/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import profile_45complete_45global from "/codebuild/output/src2732330269/src/repo/middleware/profile-complete.global.ts";
import manifest_45route_45rule from "/codebuild/output/src2732330269/src/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  profile_45complete_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/middleware/auth.ts"),
  customer: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/middleware/customer.ts"),
  driver: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/middleware/driver.ts"),
  "merchant-approved": () => import("/codebuild/output/src2732330269/src/repo/modules/auth/middleware/merchant-approved.ts"),
  "merchant-ipad": () => import("/codebuild/output/src2732330269/src/repo/modules/auth/middleware/merchant-ipad.ts"),
  merchant: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/middleware/merchant.ts"),
  onboarding: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/middleware/onboarding.ts"),
  verify: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/middleware/verify.ts"),
  "sidebase-auth": () => import("/codebuild/output/src2732330269/src/repo/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}